import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAccountData } from '../../context/AccountContext';

/**
 * Renders children only when the user has a persisted session (token + auth).
 * Otherwise redirects to login with return path in location state.
 */
export default function RequireAuth({ children, loginMessage }) {
  const { auth, token } = useAccountData();
  const location = useLocation();
  const isSignedIn = Boolean(token && auth);

  if (!isSignedIn) {
    const from = `${location.pathname}${location.search}`;
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from,
          ...(loginMessage ? { message: loginMessage } : {}),
        }}
      />
    );
  }

  return children;
}
